'use client'
import * as React from 'react'
import { BlogContentBlockProps } from './types'

const BlogContentBlock = ({ id, title, content }: BlogContentBlockProps) => {
    return (
        <div
            id={id || title?.replaceAll(' ', '-').toLowerCase()}
            className="[&>h3+p]:mt-[8px] [&>h3]:font-bold [&>h3]:text-[18px] [&>p]:text-[16px] [&>p+p]:mt-[16px] leading-[21px]"
        >
            {title && <h2 className="mb-[30px]">{title}</h2>}
            {content}
        </div>
    )
}

export default BlogContentBlock
